import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { withStyles } from '@mui/styles'

import { TariffForm } from '../form'
import { PageDisplayer, InfoBox } from '../../../../ui'
import { useTariffCalls } from '../../hooks'
import { useComunidades } from '../../../tariffs/hooks/useLoadComunidades'
import { DEFAULT_FORM_VALUES } from '../../constants'
import { tariffNewStyles } from './tariff-new.style'

export const TariffNew = withStyles(tariffNewStyles)(({ classes }) => {
  const intl = useIntl()
  const { formatMessage } = intl
  const navigate = useNavigate()
  const { newTariff, getTariffNameUnicity } = useTariffCalls()
  const { comunidades: loadedComunidades } = useComunidades()
  const empresa_id = loadedComunidades[0]?.empresa_ca_id
  const acceptsApplications = useSelector((state) => state.global?.empresa?.publica)

  const [tariff, setTariff] = useState({ ...DEFAULT_FORM_VALUES, empresa_id })

  const handleGoBack = () => {
    navigate(`/tariffs`)
  }

  const handleChange = (e) => {
    setTariff({
      ...tariff,
      [e.target.name]: e.target.value,
    })
  }

  const handleCheckName = () => {
    return new Promise((resolve, reject) => {
      getTariffNameUnicity(tariff.nombre, tariff.empresa_id).then((response) => {
        if (response) {
          resolve(response.data)
        }
        return reject('Name exists')
      })
    })
  }

  const handleSubmit = () =>
    new Promise((resolve) => {
      handleCheckName()
        .then(() => newTariff(tariff))
        .then(({ data }) => {
          const obtainedId = parseInt(data.id_tarifa)
          navigate('/tariffs/' + obtainedId + '/edit')
          resolve(obtainedId)
        })
        .catch((code) => {
          if (code === 400) {
            console.debug('Known error')
          }
        })
    })

  const handleGoToZoneConfig = () => {
    handleSubmit().then((obtainedId) => {
      navigate('/tariffs/' + obtainedId + '/zones')
    })
  }

  const inputProps = { formState: tariff, onChange: handleChange, intl }

  return (
    <PageDisplayer
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.tariffs.new.back' })}
    >
      <InfoBox
        severity="warning"
        message={formatMessage({ id: 'pages.tariffs.alerts.1.description' })}
        hidden={acceptsApplications}
      />
      <TariffForm
        {...{
          inputProps,
          submit: handleSubmit,
          goToZoneConfig: handleGoToZoneConfig,
          checkName: handleCheckName,
        }}
      />
    </PageDisplayer>
  )
})
